import React from 'react';
import { Link } from 'react-router-dom';
import { TopNav } from '../components/TopNav';

interface PageProps { theme: string; toggleTheme: () => void }

const NotFound: React.FC<PageProps> = ({ theme, toggleTheme }) => {
  return (
    <div className="min-h-screen bg-body">
      <TopNav theme={theme} toggleTheme={toggleTheme} />
      <main className="max-w-3xl mx-auto p-6 text-center">
        <h1 className="text-2xl font-extrabold text-primary mb-2">Página não encontrada</h1>
        <p className="text-sm text-muted mb-4">A rota acessada não existe.</p>
        <Link to="/" className="inline-flex items-center px-3 py-2 rounded-md bg-[#1DB954] text-black font-semibold">Voltar ao Dashboard</Link>
      </main>
    </div>
  );
};

export default NotFound;


